import { IconBin, IconDownload } from "@synthesis/shared-icons";
import { Button, FileIconComponent, Tooltip } from "@synthesis/shared-ui";

const getFileExtension = (fileName: string) => {
  const parts = fileName.split(".");
  return parts.length > 1 ? (parts.at(-1) ?? "") : "";
};

type PaymentProofFileChipProps = {
  fileName: string;
  onDownload?: () => void | Promise<void>;
  onRemove?: () => void | Promise<void>;
  disabled?: boolean;
};

export const PaymentProofFileChip = ({ fileName, onDownload, onRemove, disabled }: PaymentProofFileChipProps) => (
  <div className="bg-neutrals-95 hover:bg-neutrals-90 group flex w-full min-w-0 max-w-[26rem] items-center gap-2 rounded-sm p-0.5 transition-colors">
    <FileIconComponent className="size-6 shrink-0" ext={getFileExtension(fileName)} />
    <Tooltip description={fileName}>
      {onDownload ? (
        <button
          type="button"
          className="paragraph-sm text-system-info-50 min-w-0 flex-1 truncate text-left hover:underline"
          disabled={disabled}
          onClick={() => void onDownload()}
        >
          {fileName}
        </button>
      ) : (
        <span className="paragraph-sm text-system-info-50 min-w-0 flex-1 truncate">{fileName}</span>
      )}
    </Tooltip>
    {onDownload ? (
      <Button
        type="button"
        theme="text"
        size="xs"
        className="ml-auto hidden group-hover:block"
        disabled={disabled}
        onClick={() => void onDownload()}
        icon={<IconDownload className="size-5" />}
      />
    ) : null}
    {onRemove ? (
      <Button
        type="button"
        theme="text"
        size="xs"
        className={onDownload ? "hidden group-hover:block" : "ml-auto hidden group-hover:block"}
        disabled={disabled}
        onClick={() => void onRemove()}
        icon={<IconBin className="size-5" />}
      />
    ) : null}
  </div>
);
